import { Component, OnInit, Output, Input } from '@angular/core';

@Component({
    selector: 'app-tab-cover',
    templateUrl: './tabCover.component.html'
})
export class TabCoverComponent implements OnInit {

    @Input() lb: any;
    public img = '';
    public name = '';

    constructor() { }

    ngOnInit() {
        this.lb.widgets['dc-home'].ds.out$.subscribe(x => {
            if (x && x.company_basic_info) {
                this.img = x.company_basic_info.company_logo;
                const ragioneSociale = x.company_basic_info.general_data.find(gd => gd.label === 'Ragione Sociale');
                if (ragioneSociale) {
                    this.name = ragioneSociale.value;
                }
            }
        });
    }

}
